/* eslint-disable @typescript-eslint/no-explicit-any */
import type { IGatsbyImageData } from 'gatsby-plugin-image';
import type { FlexProps } from 'rebass';

import { withErrorBoundary } from '../../ErrorBoundary';
import RichText from '../../RichText';
import LegalFooter from '../LegalFooter';
import { MainNavigationLight } from '../MainNavigation';
import SocialIcons from '../SocialIcons';
import SubscribeForm from '../SubscribeForm';

import StyledFooter, {
  StyledContactWrapper,
  StyledFooterContactSection,
  StyledFooterMainNavigation,
  StyledFooterTopSection,
  StyledLegalWrapper,
} from './Styled';

type Link = {
  to: string;
  label: string;
};

type SubscribeForm = {
  showFooterSubscribeForm: boolean;
  showFooterSubscribeFormCountryField: boolean;
  subscribeFormHeading?: any | null;
};

interface FooterLightProps extends FlexProps {
  legalLinks: Array<Link>;
  contacts: any;
  navigation: Array<Link>;
  socialLinks: Array<Link>;
  onSubmitSubscribe: (email: string, country: string, locale: string) => Promise<number>;
  pageLocale: string;
  subscribeForm: SubscribeForm;
  banner?: {
    file: {
      url: string;
    };
    gatsbyImageData: IGatsbyImageData;
  };
}

const FooterLight = ({
  legalLinks,
  contacts,
  navigation,
  socialLinks,
  onSubmitSubscribe,
  pageLocale,
  subscribeForm,
  banner,
}: FooterLightProps) => {
  const { showFooterSubscribeForm: showSubscribeForm, showFooterSubscribeFormCountryField: showCountrySelector } =
    subscribeForm || {};

  return (
    <StyledFooter>
      <StyledFooterTopSection>
        <StyledContactWrapper>
          <RichText data={contacts.json} />
        </StyledContactWrapper>
        <StyledFooterMainNavigation>
          <MainNavigationLight navigation={navigation} />
          <SocialIcons socialLinks={socialLinks} />
        </StyledFooterMainNavigation>
        <StyledFooterContactSection>
          {showSubscribeForm && (
            <SubscribeForm
              onSubmit={(email: string, country: string) => onSubmitSubscribe(email, country, pageLocale)}
              showCountrySelector={showCountrySelector}
            />
          )}
        </StyledFooterContactSection>
      </StyledFooterTopSection>
      <StyledLegalWrapper>
        <LegalFooter items={legalLinks} banner={banner} />
      </StyledLegalWrapper>
    </StyledFooter>
  );
};

export default withErrorBoundary(FooterLight, { componentName: 'FooterLight' });
